
import { SAVE_ORIGINAL_URL } from './actionTypes';

export const saveOriginalUrl = (url) => ({
  type: SAVE_ORIGINAL_URL,
  url
});
